import { defaultChapterEndItem } from '../../systems/chapter-end-content';
import { defaultContentItem, type SceneBody } from './utils';

export const INLINE_INSERT_TYPES: Array<{ type: string; label: string; variant?: string }> = [
  { type: 'dialogue', label: 'Dialogue' },
  { type: 'dialogue', label: 'Monologue', variant: 'internal' },
  { type: 'choice', label: 'Choix' },
  { type: 'phoneChat', label: 'SMS' },
  { type: 'phoneCall', label: 'Appel overlay', variant: 'inline_call' },
  { type: 'phoneCall', label: 'Appel téléphone', variant: 'phone' },
  { type: 'phoneMail', label: 'Mail téléphone (triage)' },
  { type: 'phoneMailInteract', label: 'Mail interactif (un seul mail)' },
  { type: 'textOverlay', label: 'Overlay' },
  { type: 'timedOverlay', label: 'Transition' },
  { type: 'command', label: 'Commande' },
  { type: 'observation', label: 'Observation' },
  { type: 'clickableScreen', label: 'Écran cliquable' },
  { type: 'situationSortGame', label: 'Jeu de tri' },
  { type: 'chapterEnd', label: 'Fin de chapitre' },
  { type: 'recordCard', label: "Fiche d'arrestation" },
  { type: 'gameOver', label: 'Game over' },
];

/** Types proposés dans les branches de choix. */
export const BRANCH_INSERT_TYPES: Array<{ type: string; label: string; variant?: string }> = [
  { type: 'dialogue', label: 'Dialogue' },
  { type: 'dialogue', label: 'Monologue', variant: 'internal' },
  { type: 'gameOver', label: 'Game over' },
  { type: 'command', label: 'Commande' },
  { type: 'timedOverlay', label: 'Transition' },
];

export function makeInsertItem(type: string, variant?: string): SceneBody {
  const item = defaultContentItem(type);
  if (item.type === 'dialogue' && variant === 'internal') {
    return { ...item, type: 'dialogue', isInternal: true, speaker: 'Héros (intérieur)' };
  }
  if (item.type === 'phoneCall' && variant === 'phone') {
    return { ...item, style: 'phone' };
  }
  if (item.type === 'phoneCall' && variant === 'inline_call') {
    return { ...item, style: 'inline_call' };
  }
  return item;
}

/** Builds the body (without id) of a new scene block for the inline editor. */
export function buildInsertItem(
  type: string,
  variant?: string,
  text?: string
): SceneBody {
  let item: SceneBody = type === 'chapterEnd'
    ? defaultChapterEndItem()
    : makeInsertItem(type, variant);
  const trimmed = text?.trim() ?? '';
  if (trimmed) {
    if (item.type === 'dialogue') item = { ...item, text: trimmed };
    else if (item.type === 'choice') item = { ...item, prompt: trimmed };
    else if (item.type === 'timedOverlay') item = { ...item, message: trimmed };
    else if (item.type === 'textOverlay') item = { ...item, content: trimmed };
    else if (item.type === 'phoneChat' || item.type === 'phoneCall') {
      item = { ...item, messages: [{ sender: 'contact', text: trimmed }] };
    } else if (item.type === 'phoneMail' || item.type === 'phoneMailInteract') {
      item = { ...item, content: trimmed };
    } else if (item.type === 'chapterEnd') {
      item = { ...item, heading: trimmed };
    } else if (item.type === 'gameOver') {
      item = { ...item, text: trimmed };
    } else if (item.type === 'recordCard') {
      item = { ...item, title: trimmed };
    }
  }
  return item;
}
